/*
 * File: \libs\utils\device\src\index.js
 * Created Date: 2020-11-11 10:06:01
 * Author: gaozw
 * -----
 * Last Modified: 2020-11-11 10:20:43
 * Modified By: gaozw
 */
// 判断是否是美信应用
function isMission() {
  return (
    window.navigator.userAgent.toLocaleUpperCase().indexOf("MIDEACONNECT") > -1
  );
}

// 判断是否是ios
function isIOS() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

// 判断是否是Android
function isAndroid() {
  const u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
}


// 判断是否是纯血鸿蒙
function isHarmony() {
  const u = navigator.userAgent;
  return u.includes('OpenHarmony');
}

// 判断是否是移动端
function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile = /iphone|ipod|ipad|android|mobile/.test(userAgent)
  return isMobile
}

// 判断是否是微信环境
function isWechat() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /micromessenger/.test(userAgent);
}
// 获取IOS版本
function getIosVersion() {
  let version = null;
  if (isIOS()) {
    const ua = navigator.userAgent.toLowerCase();
    const reg = /os [\d._]+/gi;
    const info = ua.match(reg);
    version = (info + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
    version = parseInt(version.split(".")[0]);
  }

  return version;
}

function isIntelMac() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  console.log('3')
  if(userAgent.includes('windows')) return 3
  // 返回1: m1芯片
  // 返回2: intel
  // 返回3: 无法确认
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (gl) {
      const info = gl.getExtension('WEBGL_debug_renderer_info');
      if (info) {
        const renderer = gl.getParameter(info.UNMASKED_RENDERER_WEBGL).toLowerCase();
        console.log('renderer', renderer)
        if (renderer.includes('m1') || renderer.includes('m2') || renderer.includes('m3') || renderer.includes('m4')) {
          console.log('1', renderer)
          return 1;
        } else if (renderer.includes('intel')) {
          console.log('2', renderer)
          return 2;
        } else if (renderer.includes('apple gpu')) {
          console.log('3', renderer)
          return 3;
        }
      }
    }
  } catch (e) {
    console.error('WebGL 检测失败:', e);
  }
  // 2. 检查 User-Agent 中的架构信息
          // 优先检查明确的 ARM64 标识（M1/M2/M3 芯片使用 ARM 架构）
  if (userAgent.includes('arm64') || platform.includes('mac') && platform.includes('arm')) {
    return 1;
  }
  // 3. 无法确定
  return 3;
}


// 获取安卓版本
function getAndroidVersion() {
  let version = null;
  if (isAndroid()) {
    var ua = navigator.userAgent.toLowerCase();
    var reg = /android [\d._]+/gi;
    var info = ua.match(reg);
    version = (info + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
    version = parseInt(version.split(".")[0]);
  }

  return version;
}

// function isAppleSilicon() {
//   // 检查是否是 Mac 设备
//   if (navigator.platform === 'MacIntel') {
//     // 检查是否支持 Apple Silicon 特有的特性
//     // Apple Silicon 支持的最大线程数通常大于 Intel 芯片
//     return typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency > 8;
//   }
//   return false; // 非 Mac 或非 Apple Silicon
// }

// function isIntelMac() {
//   // 检查是否是 Mac 设备
//   console.log('navigator.platform', navigator.platform)
//   console.log('navigator.hardwareConcurrency', navigator.hardwareConcurrency)
//   if (navigator.platform === 'MacIntel') {
//     // 如果线程数小于等于 8，通常是 Intel 芯片
//     return typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 8;
//   }
//   return false; // 非 Mac 或非 Intel 芯片
// }

// 示例使用
// if (isAppleSilicon()) {
//   console.log('这是 Apple Silicon (ARM) 芯片的 Mac');
// } else if (isIntelMac()) {
//   console.log('这是 Intel 芯片的 Mac');
// } else {
//   console.log('这不是 Mac 或无法判断芯片类型');
// }

export default {
  isMission,
  isIOS,
  isAndroid,
  isHarmony,
  isWechat,
  getIosVersion,
  getAndroidVersion,
  isMobile,
  isIntelMac
};
